import VueI18n    from 'vue-i18n';
//import select2    from 'select2';

window.$          = window.jQuery = require('jquery');
window._          = require('lodash');
window.axios      = require('axios');
window.Vue        = require('vue');
window.moment     = require('moment');
//window.printf     = require('printf');
window.n          = require('./n');

require('./bootstrap-x');
//require('jquery.cookie');

let lang        = document.documentElement.lang;
if(['en', 'fr', 'it', 'de', 'es', 'pt'].indexOf(lang) === -1) {
    lang = 'en';
}

let messages      = { };
messages[lang]    = require('./i18n/' + lang);

window.i18n = new VueI18n({
    locale:   lang,
    messages: messages
});

$.fn.extend(n);
//$.fn.select2.defaults.set( "theme", "bootstrap" );
//$.fn.select2.defaults.set('language', lang);

import User       from './models/User';
import Supplier   from './models/Supplier';
import Rq         from './models/Rq';
import City       from './models/City';
import Work       from './models/Work';

let meta_supplier = document.head.querySelector('meta[name="n_supplier"]');
let meta_city     = document.head.querySelector('meta[name="n_city"]');
let meta_user     = document.head.querySelector('meta[name="n_user"]');
let meta_rq       = document.head.querySelector('meta[name="n_rq"]');
let meta_work     = document.head.querySelector('meta[name="n_work"]');

Vue.component('v-review',                   require('./components/reviews/default'));
Vue.component('v-review-supplier',          require('./components/reviews/supplier'));
Vue.component('v-review-supplier-by-work',  require('./components/reviews/supplierByWork'));

new Vue({

    i18n,
    el: '#main',

    data() {

        return {

            user:      meta_user     ? new User(       JSON.parse( meta_user.getAttribute(    'content')) ) : null,
            supplier:  meta_supplier ? new Supplier(   JSON.parse( meta_supplier.getAttribute('content')) ) : null,
            rq:        meta_rq       ? new Rq(         JSON.parse( meta_rq.getAttribute(      'content')) ) : null,
            city:      meta_city     ? new City(       JSON.parse( meta_city.getAttribute(    'content')) ) : null,
            work:      meta_work     ? new Work(       JSON.parse( meta_work.getAttribute(    'content')) ) : null,
        }
    },
});







// WEBPACK FOOTER //
// ./resources/js/app_vue_reviews.js